export function mfaChallengeRedirectFromError(response) {
    const redirectUrl = response?.data?.redirect_url;

    return typeof redirectUrl === "string" && redirectUrl.includes("/mfa/challenge") ? redirectUrl : null;
}

export function mfaVerificationRedirect(responseData = {}) {
    const impersonationStatus = responseData.impersonation_status;

    if (impersonationStatus !== undefined && impersonationStatus !== "completed") {
        return null;
    }

    return typeof responseData.redirect_url === "string" && responseData.redirect_url.length > 0 ? responseData.redirect_url : "/";
}

export function mfaVerificationFailure(response = {}) {
    const reason = typeof response.data?.reason === "string" ? response.data.reason : null;
    const recoveryUrl =
        typeof response.data?.recovery_url === "string"
            ? response.data.recovery_url
            : reason?.startsWith("admin_impersonation_")
              ? "/admin/owners"
              : null;

    return {
        reason,
        recoveryUrl,
        isCodeError: ["code_invalid", "code_expired", "code_locked", "code_pending"].includes(reason),
    };
}

export function isApplicationVersionError(response = {}) {
    return response.status === 410 && response.data?.reason !== "admin_impersonation_expired";
}

export function isMaintenanceError(response = {}) {
    return response.status === 503 && !["mfa_unavailable", "admin_impersonation_unavailable"].includes(response.data?.reason);
}
